<template>
<div class="chapter">
<div class="inner_page">
<p class="part-noind"><a id="page_8"><span class="txit">Understanding how America is working (and not working) is a critical first step to finding your best place in the world of work. Since the Great Recession of 2007–09, America’s work landscape has changed dramatically. Many people experienced long-term unemployment that eroded their savings, as did the mortgage crisis. (The average length of unemployment as of this writing is twenty-eight weeks, or more than a half year. But most Americans are living paycheck to paycheck, making unemployment potentially devastating.)</span></a></p><a id="page_8">
<p class="part-ind"><span class="txit">On the corporate side, even companies with big cash reserves have not been hiring at high rates. Overall hiring has picked up since the recession, but labor force participation is not as high as it was before. At the same time, the federal Affordable Care Act (referred to by some as Obamacare), signed into law in 2010, ensured that freelancers—and there are more Americans every day who fit that bill—have new options for purchasing health insurance. People in the workplace are facing increasingly complex choices about how to navigate their short- and long-term options. Understanding the forces on the economy, as well as the role played by our culture and personal desires, can help us frame the issues.</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01a.vue?4f271bf5